import { render, staticRenderFns } from "./fileazure.vue?vue&type=template&id=fc831664&"
import script from "./fileazure.vue?vue&type=script&lang=js&"
export * from "./fileazure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports